export const toTitleCase = (str) => {
  const smallWords = ["of", "in", "on", "at", "for", "with", "and", "or", "the", "a", "an","but","so","and","or"];

  return str
    .toLowerCase()
    .split(" ")
    .map((word, index) => {
      if (index !== 0 && smallWords.includes(word)) {
        return word;
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
};